(ns manage.product-selector-page.sections.combination-strategy
  (:require ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/ToggleButton$default" :as ToggleButton]
            ["@mui/material/ToggleButtonGroup$default" :as ToggleButtonGroup]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            ["react-hook-form" :as rhf]
            [cljs-bean.core :refer [->clj]]
            [common.form :as form]
            [common.widgets.form-field :refer [form-field]]
            [goog.object :as gobject]
            [manage.product-selector-page.widgets :as widgets]
            [uix.core :refer [$ defui]]))

(def rows
  #js [#js {:id 1 :list "Selector 1" :product "Product 1"}
       #js {:id 2 :list "Selector 1" :product "Product 2"}
       #js {:id 3 :list "Selector 2" :product "Product 1"}
       #js {:id 4 :list "Selector 2" :product "Product 2"}
       #js {:id 5 :list "Selector 3" :product "Product 1"}])

(def columns
  #js [#js {:field "list"
            :headerName "List #"
            :flex 1}
       #js {:field "product"
            :headerName "Product #"
            :flex 1}])

(defui edit []
  (let [{:keys [control]} (form/use-form-context)]
    ($ Stack
       {:gap 2}
       ($ rhf/Controller
          {:control control
           :name "composite-config.combination-strategy"
           :render (fn [^js props]
                     (let [{{:keys [onChange value]} :field} (->clj props)]
                       ($ :<>
                          ($ form-field
                             {:label "Combination strategy"}
                             ($ ToggleButtonGroup
                                {:direction "row"
                                 :value value
                                 :exclusive true
                                 :onChange (fn [_e value]
                                             (onChange value))}
                                ($ ToggleButton
                                   {:value "round-robin"}
                                   "Alternate")
                                ($ ToggleButton
                                   {:value "union"}
                                   "In order")))
                          ($ form-field
                             {:label "Example"}
                             ($ DataGridPremium
                                {:rows rows
                                 :columns columns
                                 :disableColumnMenu true
                                 :disableColumnSorting true
                                 :disableColumnResize true
                                 :disableRowSelectionOnClick true
                                 :sortModel (case value
                                              "union" #js [#js {:field "list" :sort "asc"}]
                                              "round-robin" #js [#js {:field "product" :sort "asc"}])
                                 :sx (fn [^js theme]
                                       #js {:border "1px solid"
                                            :borderColor (gobject/get (.. theme -palette -grey) "70")
                                            :borderRadius 1
                                            :px 1.5
                                            :py 1
                                            ".MuiDataGrid-columnHeader" #js {:borderBottom "1px solid #e0e0e0 !important"}
                                            ".MuiDataGrid-footerContainer" #js {:display "none"}})})))))}))))

(defui read []
  (let [{:keys [control]} (form/use-form-context)
        combination-strategy (rhf/useWatch #js {:name "composite-config.combination-strategy" :control control})]
    (case combination-strategy
      "union" "In order product selectors"
      "round-robin" "Alternate product selectors")))

(defui combination-strategy []
  (let [{:keys [mode]} (form/use-form-context)]
    ($ widgets/section-card
       {:title "Combination strategy"
        :tooltip "Decide how the product selectors are combined: alternate items from each list,
                  or stack one list in order one after another."}
       (if (= mode :read)
         ($ read)
         ($ edit)))))
